import { Directive, ElementRef, Input, OnInit, Renderer2 } from "@angular/core"

@Directive({
    selector: "[appAccordionItem]",
    standalone: false,
})
export class AccordionItemDirective implements OnInit {
    @Input()
    public noCount: string

    public includeInCount: boolean

    constructor(
        public el: ElementRef,
        private renderer: Renderer2
    ) {
        this.hide()
    }

    ngOnInit() {
        this.includeInCount = this.noCount === undefined
    }

    public show() {
        this.renderer.setStyle(this.el.nativeElement, "display", "block")
    }

    public hide() {
        this.renderer.setStyle(this.el.nativeElement, "display", "none")
    }
}
